<template>
    <div>
        <div
            :style="borderStyle"
            class="cruise-stappen campagnetekst width100 marginbottom15"
        >
            <div
                v-html="campagne.omschrijving_kort"
                :style="backgroundStyle"
                class="stap-header fontsize20 white padding10 uppercase"
            ></div>
            <div
                v-html="campagne.omschrijving"
                class="stap-content width90 padding10"
            ></div>
        </div>
        <div class="clear marginbottom20"></div>
    </div>
</template>

<script>
export default {
    name: 'Campagne',
    data: function() {
        return { defColor: '#378A9F' }
    },
    props: {
        campagne: Object,
    },
    computed: {
        borderStyle: function() {
            return 'border: 1px solid ' + this.campagneColor
        },
        backgroundStyle: function() {
            return 'background-color: ' + this.campagneColor
        },

        campagneColor: function() {
            if (this.campagne.color !== '') {
                return this.campagne.color
            }

            return this.defColor
        },
    },
}
</script>

<style scoped></style>
